module.exports = "/images/vendor/flag-icon-css/flags/1x1/dz.svg?b03e5aec7ad5a75fce37f5c48efe32c1";